@if (!isShrinked) {
  <i
    aria-hidden="true"
    class="pi progress-trigger pi-times"
    (click)="toggle()"
    data-cy="user-progress"
  ></i>
}

@if (user() && progress) {
  <div class="card-box user-progress" [class.shrinked]="isShrinked">
    <div class="container">
      <h1 class="onboarding-title">
        Welcome to Quotiss!
        <span class="onboarding-subtitle"> Let us show you how it works </span>
      </h1>
      <ol class="steps">
        @for (
          stepKey of getOnboardingKeys();
          track stepKey;
          let index = $index
        ) {
          <li class="step" [class.disabled]="isStepDisabled(index)">
            <div class="status">
              @if (progress[stepKey] && !isStepDisabled(index)) {
                <i class="pi pi-check-circle"></i>
              }
              @if (!progress[stepKey] || isStepDisabled(index)) {
                <span class="count">{{ index + 1 }}</span>
              }
            </div>
            <strong class="title">
              {{ onboarding[stepKey].title }}
            </strong>
            @if (!isStepDisabled(index) && onboarding[stepKey].steps) {
              <ul class="steps">
                @for (subStep of onboarding[stepKey].steps; track subStep) {
                  <li>
                    {{ subStep }}
                  </li>
                }
              </ul>
            }
            @if (isStepDisabled(index) && onboarding[stepKey].disabledMessage) {
              <ul class="steps">
                <li>
                  <div [innerHTML]="onboarding[stepKey].disabledMessage"></div>
                </li>
              </ul>
            }
            @if (onboarding[stepKey].buttons) {
              <div class="buttons">
                @if (onboarding[stepKey].buttons.moreButton) {
                  <a
                    pButton
                    severity="secondary"
                    size="small"
                    [href]="onboarding[stepKey].buttons.moreButton.url"
                    target="_blank"
                  >
                    {{ onboarding[stepKey].buttons.moreButton.label }}
                  </a>
                }
                @if (
                  onboarding[stepKey].buttons.mainButton &&
                  !isStepDisabled(index)
                ) {
                  <button
                    pButton
                    size="small"
                    [severity]="progress[stepKey] ? 'secondary' : 'success'"
                    (click)="
                      callMethod(
                        onboarding[stepKey].buttons.mainButton.callMethod
                      )
                    "
                  >
                    {{ onboarding[stepKey].buttons.mainButton.label }}
                  </button>
                }
              </div>
            }
          </li>
        }
      </ol>
    </div>
  </div>
}
